// App entry: the sign-in gate, then the tab shell. The gate shows the board to a verified Google Workspace member of
// syntaxeum.com (hd claim) or an allowlisted address (src/console/allowlist.js). UX only: enforcement is the console
// Firestore rules and the console-live functions, which apply the same rule to the same ID token.

import { el } from "./kit/dom.js";
import { onAuth, isOperator, signIn, signOutUser } from "./kit/auth.js";
import { mountTabs } from "./kit/tabs.js";

function renderSignedOut(gateRoot) {
  gateRoot.replaceChildren(
    el("div", { class: "panel", style: "max-width:420px;margin:80px auto;text-align:center" }, [
      el("h1", {}, "Ops Board"),
      el("p", { class: "sub" }, "Syntaxeum staff only. Sign in with your @syntaxeum.com Google account."),
      el("button", { onClick: () => signIn() }, "Sign in with Google"),
    ])
  );
}

function renderRefused(gateRoot, email) {
  gateRoot.replaceChildren(
    el("div", { class: "panel", style: "max-width:420px;margin:80px auto;text-align:center" }, [
      el("h1", {}, "Ops Board"),
      el("p", { class: "sub" }, `${email || "This account"} isn't authorized for the ops board.`),
      el("button", { onClick: () => signOutUser() }, "Sign out"),
    ])
  );
}

// The signed-in account and a way out, above the tabs. Before this the only Sign out was on the refused screen,
// so a permitted operator could not end their session from the board (Mark, 2026-10-15).
function renderAccount(shell, email) {
  let bar = document.getElementById("account");
  if (!bar) {
    bar = el("div", { id: "account" });
    shell.prepend(bar);
  }
  bar.replaceChildren(
    el("span", { class: "sub" }, email || ""),
    el("button", { type: "button", onClick: () => signOutUser() }, "Sign out"),
  );
}

function init() {
  const gate = document.getElementById("gate");
  const shell = document.getElementById("shell");
  const tabbar = document.getElementById("tabbar");
  const view = document.getElementById("view");

  let tabsMounted = false;

  let latest = 0;
  onAuth(async (user) => {
    const seq = ++latest;
    if (!user) {
      shell.hidden = true;
      renderSignedOut(gate);
      return;
    }
    const allowed = await isOperator(user);
    if (seq !== latest) return; // a newer auth state arrived while the token was read
    if (!allowed) {
      shell.hidden = true;
      renderRefused(gate, user.email);
      return;
    }
    gate.replaceChildren();
    renderAccount(shell, user.email);
    shell.hidden = false;
    if (!tabsMounted) {
      tabsMounted = true;
      mountTabs(tabbar, view);
    }
  });
}

init();
